@if (routeMetadata?.backLink) {
<a
  [uiSref]="routeMetadata.backLink"
  class="tw-h-10 tw-flex tw-items-center tw-gap-2 tw-text-gray-500"
>
  <mat-icon class="small medium" svgIcon="chevron-left"></mat-icon>
  {{ routeMetadata?.backLinkText || "Back" }}
</a>
} @else if (!routeMetadata?.hidePageHeader) {
<h1
  id="page-title"
  class="mt-3 tw-leading-[1.2]"
  [innerHTML]="routeMetadata?.title"
></h1>
}
